/** Klucz w localStorage do zapisanych tokenów śledzenia zamówienia. */
export const TRACKING_TOKENS_STORAGE_KEY = 'sushiking_tracking_tokens'

export interface StoredTrackingToken {
  token: string
  addedAt: number
  terminalAt?: number // Czas, kiedy zamówienie osiągnęło status końcowy
}

export function getStoredTrackingTokens(): StoredTrackingToken[] {
  if (typeof window === 'undefined') return []
  const stored = localStorage.getItem(TRACKING_TOKENS_STORAGE_KEY)
  if (!stored) return []
  try {
    return JSON.parse(stored)
  } catch {
    return []
  }
}

export function addStoredTrackingToken(token: string): void {
  if (typeof window === 'undefined' || !token) return
  const tokens = getStoredTrackingTokens()
  if (tokens.some(t => t.token === token)) return
  
  tokens.push({
    token,
    addedAt: Date.now()
  })
  
  localStorage.setItem(TRACKING_TOKENS_STORAGE_KEY, JSON.stringify(tokens))
}

export function markTokenAsTerminal(token: string): void {
  if (typeof window === 'undefined') return
  const tokens = getStoredTrackingTokens()
  const index = tokens.findIndex(t => t.token === token)
  if (index !== -1 && !tokens[index].terminalAt) {
    tokens[index].terminalAt = Date.now()
    localStorage.setItem(TRACKING_TOKENS_STORAGE_KEY, JSON.stringify(tokens))
  }
}

export function removeStoredTrackingToken(token: string): void {
  if (typeof window === 'undefined') return
  const tokens = getStoredTrackingTokens().filter(t => t.token !== token)
  localStorage.setItem(TRACKING_TOKENS_STORAGE_KEY, JSON.stringify(tokens))
}

export function clearOldTerminalTokens(): void {
  if (typeof window === 'undefined') return
  const tokens = getStoredTrackingTokens()
  const now = Date.now()
  const TWELVE_HOURS = 12 * 60 * 60 * 1000
  
  const filtered = tokens.filter(t => {
    if (!t.terminalAt) return true // Nie zakończone - zostawiamy
    return (now - t.terminalAt) < TWELVE_HOURS // Zakończone mniej niż 12h temu - zostawiamy
  })
  
  if (filtered.length !== tokens.length) {
    localStorage.setItem(TRACKING_TOKENS_STORAGE_KEY, JSON.stringify(filtered))
  }
}

// Kompatybilność wsteczna (jeśli potrzebna, ale lepiej zaktualizować wywołania)
export function getStoredTrackingToken(): string | null {
  const tokens = getStoredTrackingTokens()
  return tokens.length > 0 ? tokens[tokens.length - 1].token : null
}

export function clearStoredTrackingToken(): void {
  localStorage.removeItem(TRACKING_TOKENS_STORAGE_KEY)
}
